import { CalendarAccountIcon } from './CalendarAccountIcon';

/**
 * author: Michael Richins
 * id CD7D41D2-4BD2-4482-85C2-314A283EB57F
 * name calendar-account
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-account.svg
 * tags
 * - Date / Time 
 * - Account / User 
 */
export const CalendarUserIcon = CalendarAccountIcon;
export default CalendarUserIcon